'use client';
import React, { useState } from 'react';
import { Button, Pagination } from '@benzinga/core-ui';
import styled from '@benzinga/themetron';
import { NewsListItem } from './NewsListItem';
import Hooks from '@benzinga/hooks';
import { News } from '@benzinga/basic-news-manager';
import { RightArrow } from '@benzinga/themed-icons';

export interface NewsListWithPaginationProps {
  nodes?: News[];
  page_limit: number;
  total_items: number;
  url: string;
}

export const NewsListWithPagination = ({ nodes, page_limit, total_items, url }: NewsListWithPaginationProps) => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = Number(page_limit) || 6;
  const startItemIndex = (currentPage - 1) * itemsPerPage;
  const endItemIndex = currentPage * itemsPerPage;
  const { width } = Hooks.useWindowSize();
  const isMobile = width < 568;

  return (
    <NewsListWithPaginationWrapper className="news-list-wrapper">
      <div className="news-content-wrapper">
        {Array.isArray(nodes) &&
          nodes
            .slice(isMobile ? 0 : startItemIndex, isMobile ? 4 : endItemIndex)
            .map((news, i) => <NewsListItem key={i} news={news} />)}
      </div>
      <div className="pagination-wrapper">
        {!isMobile && (
          <Pagination
            buttonClassName="pagination-button"
            disabledPrevNextButton
            onPageChanged={data => {
              setCurrentPage(data.nextPage);
            }}
            pageNeighbors={1}
            pageSize={itemsPerPage}
            totalItems={Number(total_items) || 100}
          />
        )}
        {url && (
          <Button as="a" className="news-list-button" href={url}>
            <span>View All</span>
            <RightArrow />
          </Button>
        )}
      </div>
    </NewsListWithPaginationWrapper>
  );
};

const NewsListWithPaginationWrapper = styled.div`
  &.news-list-wrapper {
    cursor: default;
    margin: 2rem 0;

    p {
      margin: 0;
    }

    ul.pagination li.pagination-button {
      width: 40px;
      height: 36px;
      border: 1px solid #cbe0f280;
      border-radius: 4px;
      font-weight: 700;
      font-size: 14px;
      line-height: 20px;
      text-transform: uppercase;
      color: #5b7292;
      transition:
        0.25s color ease-in-out,
        0.25s border-color ease-in-out;

      &.active {
        color: #283d59;
        border-color: #cbe0f280;
      }

      &:not(.disabled):hover {
        color: #3f83f8;
        border-color: #cbe0f280;
      }
    }
  }

  .pagination-wrapper {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .news-content-wrapper {
    max-width: 100%;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 20px;

    @media screen and (max-width: 567px) {
      gap: 24px;
    }
  }

  .news-list-button {
    padding: 8px 24px;
    text-transform: uppercase;

    @media screen and (max-width: 567px) {
      width: 100%;
    }

    span {
      margin-right: 8px;
    }

    &:hover {
      color: #3f83f8;

      svg {
        fill: currentColor;
      }
    }
  }
`;
